import { c as _c } from "react-compiler-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { ASSET_ADDED_TO_FOLDER } from 'framework-listing-lib/constants/folderEvents';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import { getItem, setItem } from 'framework-listing-lib/utils/localStorage';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import { safeParseJSON } from 'framework-listing-lib/utils/json';
import useCurrentFolderId from './useCurrentFolderId';
function getLocalStorageKey(objectTypeId) {
  return `LISTING_LIB_MOVE_FOLDERS_${objectTypeId}`;
}
export function getMoveHistoryFromLocalStorage(objectTypeId) {
  const localStorageKey = getLocalStorageKey(objectTypeId);
  const storageKey = getItem(localStorageKey);
  return safeParseJSON(storageKey, {});
}
export default function useFolderMoveHistoryState() {
  "use memo";

  const $ = _c(14);
  const objectTypeId = useObjectTypeId();
  const currentFolderId = useCurrentFolderId();
  let t0;
  if ($[0] !== objectTypeId) {
    t0 = getLocalStorageKey(objectTypeId);
    $[0] = objectTypeId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const localStorageKey = t0;
  let t1;
  if ($[2] !== objectTypeId) {
    t1 = () => getMoveHistoryFromLocalStorage(objectTypeId);
    $[2] = objectTypeId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [state, setState] = useState(t1);
  let t2;
  if ($[4] !== localStorageKey) {
    t2 = value => {
      setItem(localStorageKey, JSON.stringify(value));
      setState(value);
    };
    $[4] = localStorageKey;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const updateStateAndLocalStorage = t2;
  let t3;
  let t4;
  if ($[6] !== currentFolderId || $[7] !== state || $[8] !== updateStateAndLocalStorage) {
    t3 = () => {
      const handleMove = response => {
        const {
          assetIds,
          previousFolderId
        } = response;
        if (previousFolderId !== currentFolderId) {
          return;
        }
        const copyState = Object.assign({}, state);
        if (!(currentFolderId in copyState)) {
          copyState[currentFolderId] = [];
        }
        copyState[currentFolderId] = [...new Set([...copyState[currentFolderId], ...assetIds])];
        for (const key of Object.keys(copyState)) {
          const intKey = parseInt(key, 10);
          if (intKey === currentFolderId) {
            continue;
          }
          copyState[intKey] = copyState[intKey].filter(objectId => !copyState[currentFolderId].includes(objectId));
        }
        updateStateAndLocalStorage(copyState);
      };
      listingLibObserver.on(ASSET_ADDED_TO_FOLDER, handleMove);
      return () => {
        listingLibObserver.off(ASSET_ADDED_TO_FOLDER, handleMove);
      };
    };
    t4 = [currentFolderId, state, updateStateAndLocalStorage];
    $[6] = currentFolderId;
    $[7] = state;
    $[8] = updateStateAndLocalStorage;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] !== state || $[12] !== updateStateAndLocalStorage) {
    t5 = [state, updateStateAndLocalStorage];
    $[11] = state;
    $[12] = updateStateAndLocalStorage;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}